// Privacy › Event page: hiding the event page and showing it again.
//
// Hiding saves event_privacy "unpublished". evt.live asks for a ticket only
// while event_privacy is "invite_only" (mkrn/eventlive-domain
// components/RegContext, utils/stripePurchase.mjs), and Sell Tickets sets that
// on every save. So showing a ticketed event's page again has to put
// "invite_only" back: anything else lets anyone with the link watch for free,
// and the Privacy screen of a ticketed event has no choices to fix it with.

import { t, tn } from "@/localization";

// Tickets replace the "Who can watch" choices on the Privacy screen.
export const isPayPerView = (event) =>
  !!(event?.stripe_connected_account_id && event?.pricing_mode);

const VISIBLE_PRIVACY = ["unlisted", "password_protected", "invite_only"];

// What "Show event page" saves. `before`: the privacy the page had when it
// was hidden on this screen; unknown (null) when it was hidden earlier or on
// another device, since the event doesn't keep it.
export const privacyWhenShown = ({ ticketed, before = null } = {}) => {
  if (ticketed) return "invite_only";
  return VISIBLE_PRIVACY.includes(before) ? before : "unlisted";
};

// The confirmation before hiding. `guestCount`: people on the guest list
// (ticket buyers and invited guests), or null while it isn't known.
export const hidePageConfirmation = ({ ticketed, guestCount = null } = {}) => {
  if (!ticketed) {
    return {
      title: t("Hide the event page? Guests won't be able to open it."),
    };
  }
  const count = Number.isInteger(guestCount) && guestCount > 0 ? guestCount : 0;
  return {
    title: t("Hide the event page?"),
    message: count
      ? tn(
          "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} person on your guest list will lose access.",
          "People who bought tickets won't be able to watch the live stream or the replay until you show the page again. {count} people on your guest list will lose access.",
          count
        )
      : t(
          "People who bought tickets won't be able to watch the live stream or the replay until you show the page again."
        ),
  };
};
